import { Link } from 'react-router-dom'

export default function Footer({ variant = 'light' }) {
  const bgColor = variant === 'dark' ? 'bg-black' : 'bg-white'
  const textColor = variant === 'dark' ? 'text-white' : 'text-black'
  const mutedColor = variant === 'dark' ? 'text-gray-400' : 'text-gray-500'
  const borderColor = variant === 'dark' ? 'border-gray-800' : 'border-gray-200'
  const hoverColor = variant === 'dark' ? 'hover:text-white' : 'hover:text-black'

  const currentYear = new Date().getFullYear()

  return (
    <footer className={`${bgColor} ${textColor} border-t ${borderColor} safe-area-inset-bottom`}>
      <div className="max-w-6xl mx-auto px-6 py-12">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="text-lg" style={{ fontFamily: "'DM Serif Display', Georgia, serif", letterSpacing: '-0.01em' }}>
              Dottedline.
            </Link>
            <p className={`mt-3 text-sm ${mutedColor} leading-relaxed`}>
              Football culture first.<br />
              Everything else comes second.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className={`text-xs font-medium ${mutedColor} uppercase tracking-wider mb-4`}>
              Explore
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className={`text-sm ${mutedColor} ${hoverColor} transition-colors`}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/magazine" className={`text-sm ${mutedColor} ${hoverColor} transition-colors`}>
                  Magazine
                </Link>
              </li>
              <li>
                <Link to="/shop" className={`text-sm ${mutedColor} ${hoverColor} transition-colors`}>
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/events" className={`text-sm ${mutedColor} ${hoverColor} transition-colors`}>
                  Events
                </Link>
              </li>
            </ul>
          </div>

          {/* Participate */}
          <div>
            <h4 className={`text-xs font-medium ${mutedColor} uppercase tracking-wider mb-4`}>
              Participate
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/events/yamka-games" className={`text-sm ${mutedColor} ${hoverColor} transition-colors`}>
                  Allign Sessions
                </Link>
              </li>
              <li>
                <Link to="/stats" className={`text-sm ${mutedColor} ${hoverColor} transition-colors`}>
                  Player Stats
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className={`text-sm ${mutedColor} ${hoverColor} transition-colors`}>
                  Dashboard
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className={`text-xs font-medium ${mutedColor} uppercase tracking-wider mb-4`}>
              Connect
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://instagram.com/itsdottedline"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`text-sm ${mutedColor} ${hoverColor} transition-colors inline-flex items-center gap-2`}
                >
                  Instagram
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/itsallign"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`text-sm ${mutedColor} ${hoverColor} transition-colors inline-flex items-center gap-2`}
                >
                  Twitter / X
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="mailto:aj@dottedlinepro.co.uk"
                  className={`text-sm ${mutedColor} ${hoverColor} transition-colors`}
                >
                  aj@dottedlinepro.co.uk
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className={`pt-8 border-t ${borderColor} flex flex-col md:flex-row items-center justify-between gap-4`}>
          <p className={`text-xs ${mutedColor}`}>
            &copy; {currentYear} Dottedline. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="/privacy" className={`text-xs ${mutedColor} ${hoverColor} transition-colors`}>
              Privacy Policy
            </a>
            <a href="/terms" className={`text-xs ${mutedColor} ${hoverColor} transition-colors`}>
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
